import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsService } from '@app/modules/authentication/credentials.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BaseStore } from './store-pattern/base-store.service';
export interface ICity {
  id: number;
  name: string;
}

export interface ICitiesResponse {
  cities: ICity[];
  countryId: number;
}
@Injectable({
  providedIn: 'root',
})
export class CitiesService extends BaseStore<ICitiesResponse[]> {  // Static cache to share across all instances
  private static citiesCache: { [key: string]: Observable<ICity[]> } = {};
  stores: { [key: string]: BaseStore<ICitiesResponse> } = {};

  constructor(httpClient: HttpClient, credentialsService: CredentialsService) {
    super(httpClient, credentialsService, {
      baseUrl: '/org/merchant/PickupLocation',
      getUrl: '/cities',
    });
  }
  getByCountryCode(countryCode: string): Observable<ICity[]> {
    // Normalize the country code to lowercase to ensure consistent caching
    const normalizedCountryCode = countryCode.toLowerCase();
    
    // Use cached observable if available
    if (!CitiesService.citiesCache[normalizedCountryCode]) {
      console.log(`CitiesService: Creating new cache for country code ${normalizedCountryCode}`);
      CitiesService.citiesCache[normalizedCountryCode] = this.storeByCountryCode(normalizedCountryCode)
        .getStoredData()
        .pipe(
          map((c) => {
            console.log(`CitiesService: Received cities data for ${normalizedCountryCode}`);
            return c?.cities ?? [];
          }),
          shareReplay(1) // Cache the result and share with all subscribers
        );
    } else {
      console.log(`CitiesService: Using cached data for country code ${normalizedCountryCode}`);
    }
    
    return CitiesService.citiesCache[normalizedCountryCode];
  }

  newStoreByCountryCode(countryCode: string): BaseStore<ICitiesResponse> {
    return new BaseStore<ICitiesResponse>(this.httpClient, this.credentialsService, {
      baseUrl: this.baseUrl,
      getUrl: `/${countryCode}${this.options?.getUrl}`,
      onSuccess: (data: ICitiesResponse) => {
        (this.data ??= []).push(data);
      },
    });
  }
  // Track initialization state by country code
  private static storeInitialized: { [countryCode: string]: boolean } = {};

  storeByCountryCode(countryCode: string): BaseStore<ICitiesResponse> {
    const key = `countryIdStore${countryCode}`;
    
    // Create store if it doesn't exist
    if (!this.stores[key]) {
      this.stores[key] = this.newStoreByCountryCode(countryCode);
      
      // Only initialize once per country code
      if (!CitiesService.storeInitialized[countryCode]) {
        this.stores[key].init();
        CitiesService.storeInitialized[countryCode] = true;
      }
    }
    
    return this.stores[key];
  }
}
